import { __module as j } from "./index318.js";
import { __require as J } from "./index319.js";
/*!
 * TOAST UI Editor : Color Syntax Plugin
 * @version 3.1.0 | Fri Aug 05 2022
 * @author NHN Cloud FE Development Lab <dl_javascript@nhn.com>
 * @license MIT
 */
var M;
function Q() {
  return M ? j.exports : (M = 1, (function(O, X) {
    (function(R, _) {
      O.exports = _(J());
    })(self, function(N) {
      return (
        /******/
        (function() {
          var R = {
            /***/
            858: (
              /***/
              (function(r) {
                r.exports = N;
              })
            )
            /******/
          }, _ = {};
          function c(r) {
            var o = _[r];
            if (o !== void 0)
              return o.exports;
            var u = _[r] = {
              /******/
              // no module.id needed
              /******/
              // no module.loaded needed
              /******/
              exports: {}
              /******/
            };
            return R[r](u, u.exports, c), u.exports;
          }
          (function() {
            c.n = function(r) {
              var o = r && r.__esModule ? (
                /******/
                function() {
                  return r.default;
                }
              ) : (
                /******/
                function() {
                  return r;
                }
              );
              return c.d(o, { a: o }), o;
            };
          })(), (function() {
            c.d = function(r, o) {
              for (var u in o)
                c.o(o, u) && !c.o(r, u) && Object.defineProperty(r, u, { enumerable: !0, get: o[u] });
            };
          })(), (function() {
            c.o = function(r, o) {
              return Object.prototype.hasOwnProperty.call(r, o);
            };
          })();
          var v = {};
          return (function() {
            c.d(v, {
              default: function() {
                return (
                  /* binding */
                  K
                );
              }
            });
            var r = c(858), o = /* @__PURE__ */ c.n(r);
            function u(e) {
              e.setLanguage("ar", {
                "Text color": "لون النص"
              }), e.setLanguage(["cs", "cs-CZ"], {
                "Text color": "Barva textu"
              }), e.setLanguage(["de", "de-DE"], {
                "Text color": "Textfarbe"
              }), e.setLanguage(["en", "en-US"], {
                "Text color": "Text color"
              }), e.setLanguage(["es", "es-ES"], {
                "Text color": "Color del texto"
              }), e.setLanguage(["fi", "fi-FI"], {
                "Text color": "Tekstin väri"
              }), e.setLanguage(["fr", "fr-FR"], {
                "Text color": "Couleur du texte"
              }), e.setLanguage(["gl", "gl-ES"], {
                "Text color": "Cor do texto"
              }), e.setLanguage(["hr", "hr-HR"], {
                "Text color": "Boja teksta"
              }), e.setLanguage(["it", "it-IT"], {
                "Text color": "Colore del testo"
              }), e.setLanguage(["ja", "ja-JP"], {
                "Text color": "文字色相"
              }), e.setLanguage(["ko", "ko-KR"], {
                "Text color": "글자 색상"
              }), e.setLanguage(["nb", "nb-NO"], {
                "Text color": "Tekstfarge"
              }), e.setLanguage(["nl", "nl-NL"], {
                "Text color": "Tekstkleur"
              }), e.setLanguage(["pl", "pl-PL"], {
                "Text color": "Kolor tekstu"
              }), e.setLanguage(["pt", "pt-BR"], {
                "Text color": "Cor do texto"
              }), e.setLanguage(["ru", "ru-RU"], {
                "Text color": "Цвет текста"
              }), e.setLanguage(["sv", "sv-SE"], {
                "Text color": "Textfärg"
              }), e.setLanguage(["tr", "tr-TR"], {
                "Text color": "Metin rengi"
              }), e.setLanguage(["uk", "uk-UA"], {
                "Text color": "Колір тексту"
              }), e.setLanguage("zh-CN", {
                "Text color": "文字颜色"
              }), e.setLanguage("zh-TW", {
                "Text color": "文字顏色"
              });
            }
            function B(e, t) {
              return e.classList.contains(t);
            }
            function A(e, t) {
              for (var a = e; a && !B(a, t); )
                a = a.parentElement;
              return a;
            }
            var x = "toastui-editor-";
            function U(e) {
              var t = document.createElement("button");
              return t.setAttribute("type", "button"), t.textContent = e, t;
            }
            function F(e, t) {
              return {
                name: "color",
                tooltip: t.get("Text color"),
                className: x + "toolbar-icons color",
                popup: {
                  className: x + "popup-color",
                  body: e,
                  style: { width: "auto" }
                }
              };
            }
            function z(e, t, a, g, T) {
              var k = e.mapping, L = e.doc, C = t.from, s = t.to, h = t.empty, b = k.map(C) + g.length, p = k.map(s) - T.length;
              return h ? a.create(L, p, p) : a.create(L, b, p);
            }
            function D(e, t) {
              var a = A(e, x + "defaultUI");
              return a.querySelector("." + t + " .ProseMirror");
            }
            var I, q;
            function K(e, t) {
              t === void 0 && (t = {});
              var a = e.eventEmitter, g = e.i18n, T = e.usageStatistics, k = T === void 0 ? !0 : T, L = e.pmState, C = t.preset, s = document.createElement("div"), h = { container: s, usageStatistics: k };
              u(g), C && (h.preset = C);
              var b = o().create(h), p = U(g.get("OK"));
              a.listen("focus", function(l) {
                I = "" + x + (l === "markdown" ? "md" : "ww") + "-container";
              }), s.addEventListener("click", function(l) {
                if (l.target.getAttribute("type") === "button") {
                  var n = b.getColor();
                  q = D(s, I), a.emit("command", "color", { selectedColor: n }), a.emit("closePopup"), q.focus();
                }
              }), b.slider.toggle(!0), s.appendChild(p);
              var H = F(s, g);
              return {
                markdownCommands: {
                  color: function(l, n, m) {
                    var f = l.selectedColor, i = n.tr, d = n.selection, S = n.schema;
                    if (f) {
                      var E = d.content(), w = E.content.textBetween(0, E.content.size, `
`), y = '<span style="color: ' + f + '">', P = "</span>", W = "" + y + w + P;
                      return i.replaceSelectionWith(S.text(W)).setSelection(z(i, d, L.TextSelection, y, P)), m(i), !0;
                    }
                    return !1;
                  }
                },
                wysiwygCommands: {
                  color: function(l, n, m) {
                    var f = l.selectedColor, i = n.tr, d = n.selection, S = n.schema;
                    if (f) {
                      var E = d.from, w = d.to, y = { htmlAttrs: { style: "color: " + f } }, P = S.marks.span.create(y);
                      return i.addMark(E, w, P), m(i), !0;
                    }
                    return !1;
                  }
                },
                toolbarItems: [
                  {
                    groupIndex: 0,
                    itemIndex: 3,
                    item: H
                  }
                ],
                toHTMLRenderers: {
                  htmlInline: {
                    span: function(l, n) {
                      var m = n.entering;
                      return m ? { type: "openTag", tagName: "span", attributes: l.attrs } : { type: "closeTag", tagName: "span" };
                    }
                  }
                }
              };
            }
          })(), v = v.default, v;
        })()
      );
    });
  })(j), j.exports);
}
export {
  Q as __require
};
